import {User} from './user';
import {ObjectUtil} from '../util/object-util';
import {LineOfBusiness} from './proposal/line-of-business';
import {ExpertService} from './expert-service';

export class UserPage extends User {
  introductionText: string = null;
  offeringLOBs: LineOfBusiness[] = [];
  lookingForLOBs: LineOfBusiness[] = [];
  offeringExpertServices: ExpertService[] = [];

  constructor(object: any) {
    super(object);

    if (object == null) {
      return;
    }
    ObjectUtil.assign(this, object);
  }

}
